import _module from 'module.js'

const createRedirectController = (hasQueueId = false) => {
  return (globalState, pbxUtil, $stateParams) => {
    'ngInject'
    const queueId = hasQueueId ? $stateParams.queueId : null
    pbxUtil.redirectToContactCenter(globalState.selectedPbx, queueId)
  }
}

_module.config($stateProvider => {
  'ngInject'

  $stateProvider
    .state('root.nav.pbx.contactCenterConfiguration', {
      url: '/contact-center-configuration',
      controller: createRedirectController()
    })
    .state('root.nav.pbx.contactCenterConfiguration.queues', {
      url: '/queues',
      controller: createRedirectController()
    })
    .state('root.nav.pbx.contactCenterConfiguration.queues.single', {
      url: '/:queueId',
      controller: createRedirectController(true)
    })
    .state('root.nav.pbx.contactCenterConfiguration.other', {
      url: '/*path',
      controller: createRedirectController()
    })
})
